import {useContext} from 'react'
import {CarouselCardContext, CarouselContext} from '../context'

const useIsLastCard = (): boolean => {
  const {maxCardIndex} = useContext(CarouselContext)
  const {cardIndex} = useContext(CarouselCardContext)

  return cardIndex === maxCardIndex
}

export default useIsLastCard
